import React, { useContext } from 'react';

import { Draggable, Droppable } from 'react-beautiful-dnd';

import { PacksDispatchContext } from '../ApiProvider';
import PackItemCard from '../PackItemCard';

export default function ItemList({ packItems, isContractor = false }) {
    const apiCall = useContext(PacksDispatchContext);

    const handlePackItemEdit = (id, pack_contractor) => {
        if (pack_contractor) {
            apiCall('form', {
                type: 'createContractorItem',
                id,
            });
        } else {
            apiCall('form', {
                type: 'createSimpleItem',
                id,
            });
        }
    };

    return (
        <Droppable isDropDisabled={true} droppableId="pack-items-list">
            {(provided, snapshot) => (
                <div className="flex tw-flex-col tw-h-full tw-space-y-2 tw-overflow-auto">
                    <div className="tw-rounded-lg tw-border-2 tw-border-gray-200 tw-bg-white tw-sticky tw-top-0 tw-z-10">
                        <div className="tw-p-2.5 tw-flex tw-gap-2 tw-text-sm tw-font-semibold tw-text-charcoal">
                            <div className="tw-basis-full tw-shrink tw-flex tw-flex-col tw-justify-between">
                                <div>{$t('Description')}</div>
                            </div>
                            <div className="tw-basis-full tw-shrink tw-flex tw-flex-col tw-justify-between tw-text-center">
                                <div className="tw-text-center">{isContractor ? $t('Rate Per Hour') : $t('Unit Price')}</div>
                            </div>
                            {!!packItems.some((item) => item.can_be_edited) && <div className="tw-basis-6 tw-shrink-0"></div>}
                        </div>
                    </div>
                    <div className="tw-space-y-2" ref={provided.innerRef} {...provided.droppableProps}>
                        {(!!packItems.length &&
                            packItems.map((packItem, i) =>
                                packItem.deleted ? (
                                    ''
                                ) : (
                                    <Draggable key={packItem.id} draggableId={packItem.id.toString()} index={i}>
                                        {(provided, snapshot) => (
                                            <div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                                                <PackItemCard
                                                    key={packItem.id}
                                                    type={packItem.pack_contractor ? 'contractor' : 'simple'}
                                                    item={packItem}
                                                    onEdit={() => handlePackItemEdit(packItem.id, packItem.pack_contractor)}
                                                    fullSize={false}
                                                />
                                            </div>
                                        )}
                                    </Draggable>
                                ),
                            )) || <NoItemsFound />}
                        <div className="d-none">{provided.placeholder}</div>
                    </div>
                </div>
            )}
        </Droppable>
    );
}

const NoItemsFound = () => {
    return <p className="tw-text-sm tw-text-charcoal-50">{$t('No packs items found')}</p>;
};
